import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Point from '@mapbox/point-geometry';
/**
 * @internal
 * Shared utilities for the Handler classes to access the correct camera state.
 * If Camera.transformCameraUpdate is specified, the "desired state" of camera may differ from the state used for rendering.
 * The handlers need the "desired state" to track accumulated changes.
 */
export class TransformProvider {
  constructor(map) {
    _defineProperty(this, "_map", void 0);
    this._map = map;
  }
  get transform() {
    return this._map._requestedCameraState || this._map.transform;
  }
  get center() {
    return {
      lng: this.transform.center.lng,
      lat: this.transform.center.lat
    };
  }
  get zoom() {
    return this.transform.zoom;
  }
  get pitch() {
    return this.transform.pitch;
  }
  get bearing() {
    return this.transform.bearing;
  }
  unproject(point) {
    return this.transform.pointLocation(Point.convert(point));
  }
}